import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../utils/date.utils';

@Pipe({
  name: 'formatShippingDate'
})
export class FormatShippingDatePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return DateUtils.formatShippingDate(value);
  }
}
